import axios from 'axios';

// Determine the API base URL based on environment
export const getApiBaseUrl = () => {
  // The production application is Vercel + Supabase only. Keep legacy callers
  // same-origin so a stale VITE_API_URL can never reintroduce an external API.
  return '';
};

// Create a custom axios instance with the server URL
const api = axios.create({
  baseURL: getApiBaseUrl(), // Use the dynamic base URL
  headers: {
    'Content-Type': 'application/json',
  },
  // Enable cookies/credentials if your API uses authentication
  withCredentials: true,
  // Add timeout for development debugging
  timeout: 30000, // 30 seconds
});

// Add request interceptor for debugging
api.interceptors.request.use(
  config => {
    console.log('[API Request]', config.method?.toUpperCase(), config.url);
    return config;
  },
  error => {
    console.error('[API Request Error]', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  response => {
    console.log('[API Response]', response.status, response.config.url);
    return response;
  },
  error => {
    // Log more details about the error
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('API Response Error:', {
        data: error.response.data,
        status: error.response.status,
        headers: error.response.headers,
        config: error.config,
        url: error.config?.url
      });
    } else if (error.request) {
      // The request was made but no response was received
      console.error('API No Response Error:', {
        request: error.request,
        message: error.message,
        url: error.config?.url
      });
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('API Setup Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api; 
